import Post from "../../Post";
import getToken from "../../token";

export default function headByAge(childId) {
  return Post("test/headSizeByAgeGrowthDetaileDoctor", {
    token: getToken(),
    childId: childId,
  });
}
